import { SUPABASE_ANON_KEY } from '@/constants/env';

import { readAccessToken } from './supabaseClient';

const SUPABASE_HEADERS: Record<string, string> = { apikey: SUPABASE_ANON_KEY };

const PUBLIC_FUNCTION_HEADERS: Record<string, string> = { ...SUPABASE_HEADERS, Authorization: `Bearer ${SUPABASE_ANON_KEY}` };

const withSessionHeaders = async (): Promise<Record<string, string>> => {
  const token = await readAccessToken();

  if (!token) {
    return SUPABASE_HEADERS;
  }

  return { ...SUPABASE_HEADERS, Authorization: `Bearer ${token}` };
};

export {
  PUBLIC_FUNCTION_HEADERS,
  SUPABASE_HEADERS,
  withSessionHeaders,
};
